import { render, staticRenderFns } from "./copy-term.vue?vue&type=template&id=661a4d7e"
import script from "./copy-term.vue?vue&type=script&lang=js"
export * from "./copy-term.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports